import AuthProvider from '@/auth/AuthProvider';
import Layout from '@/layout/Layout';
import Home from '@/pages/home';
import Login from '@/pages/login/Login';
import AuthRoute from '@/routes/AuthRoute';
import '@/style';
import { ConfigProvider } from '@qsxy/element-plus-react';
import { useRef } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { AppContext } from './AppContext';
import NotFound from './pages/404';
import ChatView from './pages/chat/ChatView';
import Knowledge from './pages/knowledge';
import Register from './pages/register/Register';
import Setting from './pages/settings/Index';
import SafeSetting from './pages/settings/SafeSetting';
import UserInfo from './pages/settings/UserInfo';
import Versions from './pages/versions';
import ShareInfo from './pages/share';

const App = () => {
	const conversationTitle = useRef('');
	const conversationType = useRef('');
	const conversationId = useRef('');
	const refreshConversation = useRef(null);

	const router = createBrowserRouter(
		createRoutesFromElements(
			<>
				<Route path="/version" element={<Versions />} />
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />
				<Route path="*" element={<NotFound />} />
				<Route path="/" element={<Layout />}>
					<Route
						path="/chat"
						index
						element={
							<AuthRoute>
								<Home />
							</AuthRoute>
						}
					/>
					<Route path="/knowledge" element={<Knowledge />} />
					<Route path="/chat/:id" element={<ChatView />} />
					<Route path="/setting" element={<Setting />}>
						<Route path="userInfo" element={<UserInfo />} />
						<Route path="safeSetting" element={<SafeSetting />} />
					</Route>
				</Route>
			</>,
		),
	);

	return (
		<AuthProvider>
			<ConfigProvider.Provider value={{ inputNumber: { controlsPositionRight: true } }}>
				<AppContext.Provider value={{ conversationTitle, localConversationId: conversationId, conversationType, refreshConversation }}>
					<RouterProvider router={router} />
				</AppContext.Provider>
			</ConfigProvider.Provider>
		</AuthProvider>
	);
};

export default App;
